
import { SELECTED_REQUESTERID } from "./type"


const reqId = localStorage.getItem('requesterId')
const initialState = {
    requesterId : reqId || undefined }
const selectedretailerReqesterReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case SELECTED_REQUESTERID:
            return {
               ...state,
               requesterId: action.payload?.reqId
            }
        default:
            return state
    }
}

export default selectedretailerReqesterReducer